module.exports = __webpack_public_path__ + "static/media/Transfer.38ff62e0.svg";